import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { MenuItem, Typography } from '@mui/material';
import { $filters, $savedFilters } from '../../model';
import { Loader } from '../../molecules/loader';
import { LocalLoader } from '../../molecules/localLoader';
import { Props } from '../page';
import { DeleteItem } from './deleterFilters';
import { SaveItem } from './saveFilters';
import { SavedFiltersList } from './savedFiltersList';
import { MenuHeader } from './styled';
import * as Styled from './styled';

export const FilterMenu = ({
  isFilterDefault,
  resetFilters,
  setFiltersOutside,
}: {
  isFilterDefault: boolean;
  resetFilters: Props['resetFilters'];
  setFiltersOutside: Props['setFiltersOutside'];
}) => {
  const { t } = useTranslation();
  const [filters, savedFilters] = useUnit([$filters, $savedFilters]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const hideMenuItems = isFilterDefault && !savedFilters.length;

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (hideMenuItems) return;

    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const nowFiltersJsonString = JSON.stringify(filters);

  const checkedSavedFilters = savedFilters.find(
    ({ filtersJsonString }) => filtersJsonString === nowFiltersJsonString
  );

  const mainButtonText = () => {
    if (checkedSavedFilters) return checkedSavedFilters.name;

    return isFilterDefault ? t('NotSet1') : t('Custom');
  };

  const resetFiltersFunc = () => {
    resetFilters();
    handleClose();
  };

  return (
    <div>
      <MenuHeader>
        <Typography variant="body2" color="text.secondary">
          {t('Filter')}:
        </Typography>

        <Styled.MainButton
          variant="text"
          size="small"
          color="primary"
          onClick={handleClick}
          disabled={hideMenuItems}
        >
          {mainButtonText()}
        </Styled.MainButton>

        <LocalLoader />
      </MenuHeader>

      <Styled.Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Loader />

        <Styled.MenuContainer>
          {!checkedSavedFilters && !isFilterDefault && <SaveItem />}

          {checkedSavedFilters && (
            <DeleteItem checkedSavedFilters={checkedSavedFilters} />
          )}

          {!isFilterDefault && (
            <MenuItem disableRipple onClick={resetFiltersFunc}>
              {t('Reset')}
            </MenuItem>
          )}

          <SavedFiltersList
            checkedSavedFilters={checkedSavedFilters}
            isDivider={!!checkedSavedFilters || !isFilterDefault}
            setFiltersOutside={setFiltersOutside}
            handleClose={handleClose}
          />
        </Styled.MenuContainer>
      </Styled.Menu>
    </div>
  );
};
